import type {SVGProps, FC} from 'react';

export const PinIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg viewBox='0 0 24 24' fill='currentColor' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path
                d='M21.7 9.8L20.7 8.8L14.2 2.3C13.8 1.9 13.2 1.9 12.8 2.3C12.4 2.7 12.4 3.3 12.8 3.7L13.1 4L8.7 8.4C7 8.2 5.3 8.4 3.7 9.1C3.3 9.2 3.1 9.5 3 9.8C3 10.1 3.1 10.5 3.3 10.7L7.6 15L3.5 19L2.5 21.5L5 20.5L9 16.5L13.2 20.8C13.4 21 13.8 21.1 14.1 21.1C14.4 21 14.7 20.8 14.8 20.5C15.4 18.9 15.7 17.2 15.5 15.5L20 10.9L20.3 11.2C20.7 11.6 21.3 11.6 21.7 11.2C22.1 10.8 22.1 10.2 21.7 9.8Z'
            />
        </svg>
    );
};

